export default __webpack_public_path__ + "static/media/Join_Network_banner.48aa8fe9.png";